import React, { useState, createContext, useContext } from 'react';
export interface CartItem {
  id: string;
  type: 'subscription' | 'wallet' | 'addon';
  name: string;
  description: string;
  price: number;
  details?: string;
}
interface BillingCartContextType {
  items: CartItem[];
  addItem: (item: CartItem) => void;
  removeItem: (id: string) => void;
  clearCart: () => void;
  total: number;
  itemCount: number;
  walletBalance: number;
  setWalletBalance: (balance: number) => void;
}
const BillingCartContext = createContext<BillingCartContextType | undefined>(undefined);
export function BillingCartProvider({
  children
}: {
  children: ReactNode;
}) {
  const [items, setItems] = useState<CartItem[]>([]);
  const [walletBalance, setWalletBalance] = useState(12450.5);
  const addItem = (item: CartItem) => {
    setItems(prev => {
      // Replace if same type exists (for subscription/wallet), add for addons
      if (item.type === 'subscription' || item.type === 'wallet') {
        return [...prev.filter(i => i.type !== item.type), item];
      }
      // For addons, check if same addon exists
      const exists = prev.find(i => i.id === item.id);
      if (exists) return prev;
      return [...prev, item];
    });
  };
  const removeItem = (id: string) => {
    setItems(prev => prev.filter(item => item.id !== id));
  };
  const clearCart = () => {
    setItems([]);
  };
  const total = items.reduce((sum, item) => sum + item.price, 0);
  const itemCount = items.length;
  return <BillingCartContext.Provider value={{
    items,
    addItem,
    removeItem,
    clearCart,
    total,
    itemCount,
    walletBalance,
    setWalletBalance
  }} data-id="element-1193">
      {children}
    </BillingCartContext.Provider>;
}
export function useBillingCart() {
  const context = useContext(BillingCartContext);
  if (!context) {
    throw new Error('useBillingCart must be used within BillingCartProvider');
  }
  return context;
}